// extracted by mini-css-extract-plugin
export var outerContainer = "FigureGrid-module--outer-container--OR3xo";
export var innerContainer = "FigureGrid-module--inner-container--Ttz75";